import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { REVIT_URI_SCHEME } from './revit-deep-link-constants';

interface OpenInRevitButtonProps {
  uri: string;
}

// Validates that `uri` is a well-formed bamt-revit:// deep-link.
// The URL constructor rejects invalid characters (control chars, null bytes, etc.)
// but doesn't accept custom schemes, so we substitute https:// for structural
// validation and then confirm the original scheme is exactly bamt-revit://.
const isValidRevitUri = (uri: string): boolean => {
  if (!uri.startsWith(REVIT_URI_SCHEME)) return false;
  try {
    const probe = new URL('https://' + uri.slice(REVIT_URI_SCHEME.length));
    return probe.hostname.length > 0;
  } catch {
    return false;
  }
};

export const OpenInRevitButton = ({ uri }: OpenInRevitButtonProps) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (!isValidRevitUri(uri)) {
      return;
    }
    window.location.href = uri;
  };

  return (
    <Tooltip title={t('revit.deepLink.openInRevit')}>
      <IconButton
        size="small"
        color="default"
        onClick={handleClick}
        aria-label={t('revit.deepLink.openInRevit')}
      >
        <OpenInNewIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default OpenInRevitButton;
